import { ResourceHelper } from 'bog-arcade-core-ui';

export const resourceHelper = new ResourceHelper()
